import { debug } from 'lib/logging'

export async function run<T>(promiseOrAsyncFunc: Promise<T> | ((...args: any[]) => Promise<T>)): Promise<T> {
  if (typeof promiseOrAsyncFunc === `function`) {
    // eslint-disable-next-line @typescript-eslint/return-await
    try {
      return await promiseOrAsyncFunc()
      // oxlint-disable-next-line local/require-catch-logging
    } catch (err) {
      debug(`match`, `error in run block`, err)
      throw err
    }
  } else {
    return promiseOrAsyncFunc
  }
}
